<!DOCTYPE html>
<html lang="ms">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>RekodPay - Automasi Jualan WhatsApp</title>
    <style>
        * {
            box-sizing: border-box;
        }

        body {
            background-color: #f8fafc;
            color: #0f172a;
            margin: 0;
            font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        /* Navbar */
        .navbar {
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #e2e8f0;
        }

        .nav-brand {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .brand-name {
            font-size: 20px;
            font-weight: 700;
            letter-spacing: -0.5px;
            color: #0f172a;
        }

        .nav-actions {
            display: flex;
            align-items: center;
            gap: 16px;
        }

        .btn-register {
            background-color: #2563eb;
            border: none;
            color: #ffffff;
            font-size: 14px;
            font-weight: 600;
            padding: 10px 20px;
            border-radius: 10px;
            cursor: pointer;
            box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.2);
            transition: background-color 0.2s;
        }

        .btn-register:hover {
            background-color: #1d4ed8;
        }

        /* Main Center Content */
        .main-container {
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            padding: 40px 24px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 48px;
            flex: 1;
        }

        .hero-content {
            flex: 1;
        }

        .badge {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            background-color: #eff6ff;
            border: 1px solid #bfdbfe;
            padding: 6px 14px;
            border-radius: 50px;
            color: #1d4ed8;
            font-size: 12px;
            font-weight: 600;
            margin-bottom: 24px;
        }

        .badge-dot {
            width: 8px;
            height: 8px;
            background-color: #2563eb;
            border-radius: 50%;
            animation: pulse 1.5s infinite;
        }

        @keyframes pulse {
            0% {
                transform: scale(0.95);
                opacity: 0.8;
            }
            50% {
                transform: scale(1.3);
                opacity: 0.4;
            }
            100% {
                transform: scale(0.95);
                opacity: 0.8;
            }
        }

        h1 {
            font-size: 48px;
            font-weight: 900;
            line-height: 1.1;
            letter-spacing: -1px;
            color: #0f172a;
            margin-top: 0;
            margin-bottom: 20px;
        }

        h1 span {
            background: linear-gradient(90deg, #2563eb, #3b82f6);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .description {
            font-size: 16px;
            color: #475569;
            line-height: 1.6;
            margin-bottom: 32px;
            max-width: 540px;
        }

        .cta-group {
            display: flex;
            gap: 16px;
            margin-bottom: 24px;
        }

        .btn-primary {
            background-color: #2563eb;
            color: #ffffff;
            border: none;
            padding: 14px 28px;
            font-size: 14px;
            font-weight: 700;
            border-radius: 12px;
            cursor: pointer;
            box-shadow: 0 10px 20px -5px rgba(37, 99, 235, 0.3);
            transition: background 0.2s;
            width: 100%;
        }

        .btn-primary:hover {
            background-color: #1d4ed8;
        }

        .features-list {
            display: flex;
            gap: 24px;
            font-size: 12px;
            color: #64748b;
            font-weight: 500;
        }

        /* Right Card Mockup */
        .hero-card-wrapper {
            flex: 0.8;
            width: 100%;
        }

        .mockup-card {
            background-color: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 16px;
            padding: 24px;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05);
            width: 100%;
        }

        .mockup-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 12px;
            border-bottom: 1px solid #f1f5f9;
            margin-bottom: 16px;
        }

        .whatsapp-box {
            background-color: #f1f5f9;
            border: 1px solid #e2e8f0;
            padding: 16px;
            border-radius: 12px;
            margin-bottom: 16px;
            word-break: break-word;
        }

        .whatsapp-label {
            font-size: 10px;
            font-weight: 700;
            color: #64748b;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 6px;
        }

        .whatsapp-text {
            font-size: 13px;
            color: #334155;
            font-style: italic;
            line-height: 1.4;
        }

        .status-box {
            background-color: #eff6ff;
            border: 1px solid #bfdbfe;
            padding: 16px;
            border-radius: 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
        }

        .status-title {
            font-size: 10px;
            font-weight: 800;
            color: #1d4ed8;
            letter-spacing: 0.5px;
            margin-bottom: 2px;
        }

        .status-desc {
            font-size: 12px;
            color: #0f172a;
            font-weight: 600;
        }

        .status-badge {
            background-color: #2563eb;
            color: #ffffff;
            font-weight: 900;
            font-size: 12px;
            padding: 6px 12px;
            border-radius: 20px;
            white-space: nowrap;
        }

        /* Footer */
        .footer {
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 1px solid #e2e8f0;
            font-size: 12px;
            color: #64748b;
        }

        /* --- Mobile Responsive Adjustments --- */
        @media (max-width: 768px) {
            .navbar {
                height: 70px;
                padding: 0 16px;
            }

            .main-container {
                flex-direction: column;
                padding: 30px 16px;
                gap: 32px;
                text-align: center;
            }

            h1 {
                font-size: 30px;
                line-height: 1.2;
            }

            .description {
                margin-left: auto;
                margin-right: auto;
                font-size: 14px;
            }

            .badge {
                margin-left: auto;
                margin-right: auto;
                text-align: left;
            }

            .cta-group {
                width: 100%;
            }

            .features-list {
                justify-content: center;
                flex-wrap: wrap;
                gap: 12px;
            }

            .hero-card-wrapper {
                width: 100%;
            }

            .mockup-card {
                padding: 16px;
            }

            .footer {
                justify-content: center;
                height: auto;
                padding: 20px 16px;
                text-align: center;
            }
        }
    </style>
</head>

<body>

    <!-- Navbar -->
    <header class="navbar">
        <div class="nav-brand">
            <span class="brand-name">RekodPay</span>
        </div>
        <div class="nav-actions">
            <a href="https://wa.me/60178979344" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">
                <button class="btn-register">Mula Sekarang</button>
            </a>
        </div>
    </header>

    <!-- Center Content -->
    <main class="main-container">
        <div class="hero-content">
            <div class="badge">
                <span class="badge-dot"></span>
                <span>Mudahkan Bisnes WhatsApp, Urus Order & Jana Invois Sekelip Mata</span>
            </div>
            <h1>Ubah Mesej WhatsApp ke <span>Invois dan Resit</span> Secara Automatik.</h1>
            <p class="description">
                Sistem pantas untuk peniaga mengurus pesanan pelanggan, pantau rekod jualan, jana invois dan resit rasmi
                tanpa pening kepala.
            </p>
            <div class="cta-group">
                <a href="https://wa.me/60178979344" target="_blank" rel="noopener noreferrer"
                    style="text-decoration: none; width: 100%;">
                    <button class="btn-primary">Cuba Sekarang</button>
                </a>
            </div>
            <div class="features-list">
                <span>✓ Pantau pembayaran</span>
                <span>✓ Invois PDF</span>
                <span>✓ Laporan jualan</span>
            </div>
        </div>

        <div class="hero-card-wrapper">
            <div class="mockup-card">
                <div class="mockup-header">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <!-- WhatsApp SVG Icon -->
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="#25D366"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.124-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                        </svg>
                        <span style="font-size: 12px; font-weight: 600; color: #64748b;">WhatsApp</span>
                    </div>
                </div>

                <div class="whatsapp-box">
                    <div class="whatsapp-label">Anda hantar pada RekodPay</div>
                    <div class="whatsapp-text">"Kek Lapis 2 Name: Kamal Phone: 0133344556 Address: Taman Melawati KL"</div>
                </div>

                <div class="whatsapp-box">
                    <div class="whatsapp-label">RekodPay balas</div>
                    <div class="whatsapp-text">"✓ Invois TXN-1784812113281 selesai dijana!"</div>
                </div>

                <div class="status-box">
                    <div>
                        <div class="status-title">STATUS TRANSAKSI DI DASHBOARD</div>
                        <div class="status-desc">Order direkod & Invois Dijana</div>
                    </div>
                    <div class="status-badge">PAID</div>
                </div>
            </div>
        </div>
    </main>

    <!-- Footer -->
    <footer class="footer">
        <span>© 2026 RekodPay. Hak cipta terpelihara.</span>
    </footer>

</body>

</html>